import { render, staticRenderFns } from "./enter-vr-button.component.vue?vue&type=template&id=46f4f1c2"
import script from "./enter-vr-button.component.vue?vue&type=script&lang=js"
export * from "./enter-vr-button.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports